import { Injectable } from '@angular/core';
import { IFillBySource } from "../dasboard-admin-chart-details.model";

@Injectable()
export class FillBySourceService {

    public calculateAvgFill(data: IFillBySource[]): number {
        if (data) {
            let totalRequested = 0;
            let totalReady = 0;
            data.forEach(s => { totalRequested += s.contentRequested; totalReady += s.contentReady });
            if (totalReady > totalRequested) return 100;
            return (100 * totalReady) / totalRequested;
        }
        return 0;
    }

    public calculateOverAllFill(data: IFillBySource[], totalRequests: number) {
        if (data && totalRequests) {
            let totalReady = 0;
            data.forEach(s => totalReady += s.contentReady);
            if (totalReady > totalRequests) return 100;
            return (100 * totalReady) / totalRequests;
        }
        return 0;
    }

}


// WEBPACK FOOTER //
// ./src/app/dashboard/fillbysource/fill-by-source.service.ts